import * as React from 'react';
import { useAppLayout } from '@context/LayoutContext';
import MobileLuckyWheelCampaign from './Mobile/LuckyWheelCampaignTab';
import DesktopLuckyWheelCampaign from './LuckyWheelCampaign';

interface LuckyWheelCampaignProps {
  id: string;
  setVisible?: React.Dispatch<React.SetStateAction<boolean>>;
}
const LuckyWheelCampaign = React.memo((props: LuckyWheelCampaignProps) => {
  const { isMobile } = useAppLayout();
  const LuckyWheelCampaignComponent = isMobile ? MobileLuckyWheelCampaign : DesktopLuckyWheelCampaign;

  return <LuckyWheelCampaignComponent {...props} />;
});

export default LuckyWheelCampaign;
